<div class="content-wrapper blog-list-page">
    <div class="content-body">
        <section class="blog-toolbar">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
                <div>
                    <h2 class="page-title mb-0">Blog Posts</h2>
                    <p class="text-muted mb-0">Manage articles, categories and tags</p>
                </div>
                <div class="toolbar-actions d-flex flex-wrap">
                    <button class="btn btn-outline-secondary mr-1 mb-1" routerLink="/blogs/categories">
                        <i class="fa fa-folder-open mr-1"></i> Categories
                    </button>
                    <button class="btn btn-outline-secondary mr-1 mb-1" routerLink="/blogs/tags">
                        <i class="fa fa-tags mr-1"></i> Tags
                    </button>
                    <button class="btn btn-primary mb-1" (click)="create()">
                        <i class="fa fa-plus mr-1"></i> New Post
                    </button>
                </div>
            </div>
        </section>

        <section class="blog-filters card">
            <form [formGroup]="searchForm" class="row p-2 align-items-end">
                <div class="col-12 col-md-5 mb-1 mb-md-0">
                    <label class="form-label small text-uppercase text-muted">Search</label>
                    <input type="text" class="form-control" formControlName="title" placeholder="Search by title...">
                </div>
                <div class="col-6 col-md-3 mb-1 mb-md-0">
                    <label class="form-label small text-uppercase text-muted">Status</label>
                    <select class="form-control" formControlName="status">
                        <option value="">All</option>
                        <option value="DRAFT">Draft</option>
                        <option value="PUBLISHED">Published</option>
                    </select>
                </div>
                <div class="col-6 col-md-3 mb-1 mb-md-0">
                    <label class="form-label small text-uppercase text-muted">Category</label>
                    <select class="form-control" formControlName="category_id">
                        <option value="">All</option>
                        <option *ngFor="let c of categories" [value]="c.id">{{ c.name }}</option>
                    </select>
                </div>
                <div class="col-12 col-md-1 text-right">
                    <button type="button" class="btn btn-link btn-block p-0" (click)="resetFilters()">Clear</button>
                </div>
            </form>
        </section>

        <ng-container *ngIf="!loading; else loadingTpl">
            <ng-container *ngIf="blogs.length > 0; else emptyState">
                <section class="blog-grid">
                    <div class="blog-card" *ngFor="let blog of blogs">
                        <div class="blog-card__cover">
                            <img *ngIf="coverUrl(blog); else noCover" [src]="coverUrl(blog)" [alt]="blog.title">
                            <ng-template #noCover>
                                <div class="no-cover">
                                    <i class="fa fa-image"></i>
                                </div>
                            </ng-template>
                            <span class="status-pill" [class.published]="blog.status === 'PUBLISHED'"
                                  [class.draft]="blog.status === 'DRAFT'">
                                {{ blog.status === 'PUBLISHED' ? 'Published' : 'Draft' }}
                            </span>
                            <span *ngIf="blog.is_featured" class="featured-pill">
                                <i class="fa fa-star"></i> Featured
                            </span>
                        </div>
                        <div class="blog-card__body">
                            <div class="blog-meta">
                                <span *ngIf="blog.category" class="meta-chip">{{ blog.category.name }}</span>
                                <span class="text-muted small">
                                    {{ (blog.published_at || blog.created_at) | date: 'mediumDate' }}
                                </span>
                            </div>
                            <h5 class="blog-title">{{ blog.title }}</h5>
                            <p class="blog-intro">{{ blog.intro }}</p>
                            <div class="blog-tags" *ngIf="blog.tags?.length">
                                <span class="tag-chip" *ngFor="let t of blog.tags">#{{ t.name }}</span>
                            </div>
                        </div>
                        <div class="blog-card__footer">
                            <small class="text-muted">
                                <i class="fa fa-eye mr-1"></i> {{ blog.views || 0 }}
                                <span class="mx-1">·</span>
                                <i class="fa fa-user mr-1"></i> {{ blog.author?.name || '—' }}
                            </small>
                            <div>
                                <button class="btn btn-sm btn-outline-primary btn-icon mr-1" (click)="edit(blog)" aria-label="Edit">
                                    <span [data-feather]="'edit-2'" [size]="14"></span>
                                </button>
                                <button class="btn btn-sm btn-outline-danger btn-icon" (click)="remove(blog)" aria-label="Delete">
                                    <span [data-feather]="'trash-2'" [size]="14"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="d-flex justify-content-center mt-3">
                    <ngb-pagination class="pagination-primary"
                                    [collectionSize]="pagination.total"
                                    [(page)]="pagination.page"
                                    [boundaryLinks]="true"
                                    [pageSize]="pagination.perpage"
                                    [maxSize]="5"
                                    (pageChange)="onPageChange($event)">
                    </ngb-pagination>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #emptyState>
            <div class="empty-state text-center py-5">
                <div class="empty-icon"><i class="fa fa-newspaper-o"></i></div>
                <h4 class="mt-3">No posts yet</h4>
                <p class="text-muted">Create your first blog post to get started.</p>
                <button class="btn btn-primary" (click)="create()">
                    <i class="fa fa-plus mr-1"></i> Create Post
                </button>
            </div>
        </ng-template>

        <ng-template #loadingTpl>
            <div class="text-center py-5">
                <div class="spinner-border text-primary" role="status"></div>
            </div>
        </ng-template>
    </div>
</div>
